export default __webpack_public_path__ + "static/media/1.85c3ae6f.png";